import { ModuleModel } from '../../module.model.interface';

export enum CaseCreatorType {
  Anonymous,
  IdentifiedNoOrganization,
  IdentifiedWithOrganization
}

export class CaseCreatorTypeDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CaseCreatorTypeMap = {
  Anonymous: new CaseCreatorTypeDetail({ id: 'Anonymous', name: 'Anonim felhasználó' }),
  IdentifiedNoOrganization: new CaseCreatorTypeDetail({ id: 'IdentifiedNoOrganization', name: 'Azonosított felhasználó - szervezet nélkül' }),
  IdentifiedWithOrganization: new CaseCreatorTypeDetail({ id: 'IdentifiedWithOrganization', name: 'Azonosított felhasználó - szervezettel' }),
};

export const CaseCreatorTypeList: CaseCreatorTypeDetail[] = [
  CaseCreatorTypeMap.Anonymous,
  CaseCreatorTypeMap.IdentifiedNoOrganization,
  CaseCreatorTypeMap.IdentifiedWithOrganization,
];

export class CaseCategoryDescriptor implements ModuleModel {
  public discriminator = 'CaseCategoryDescriptor';

  public id: string;

  public name: string;
  public isOrganizationRequired: boolean;
  public isFormRequired: boolean;
  public isDataPeriodRequired: boolean;
  public allowAttachments: boolean;
  public allowedCreatorType: CaseCreatorType;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;

    name: string;
    isOrganizationRequired: boolean;
    isFormRequired: boolean;
    isDataPeriodRequired: boolean;
    allowAttachments: boolean;
    allowedCreatorType: CaseCreatorType;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.name = options.name;
      this.isOrganizationRequired = options.isOrganizationRequired;
      this.isFormRequired = options.isFormRequired;
      this.isDataPeriodRequired = options.isDataPeriodRequired;
      this.allowAttachments = options.allowAttachments;
      this.allowedCreatorType = options.allowedCreatorType;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case.category/model/case.category.ts